const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'prisma_header',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {
        update(data) {
            this.model.update(data);
        },
    },
});
